import {BookWelcomeToTheWoldData, CommonBookData} from '@functions/models';
import {THairStyle, TParents} from '@shared/book/interfaces';
import moment from 'moment-timezone';
import {MONTH_INDEX_TO_TIME_OF_THE_YEAR_MAP} from '@shared/book/maps';
import {BOOK_ALIAS_WELCOME_TO_THE_WOLD} from '@shared/book/constants';
import {IBookCreate} from 'src/app/services/book-create/book-create';
import {firestore} from 'firebase';
import Timestamp = firestore.Timestamp;


export class WelcomeToTheWoldBookCreate implements IBookCreate<BookWelcomeToTheWoldData> {
  createNewBook(
    uid: string,
    docId: string,
    heroName: string,
    birthDate: Date,
    hairStyle: THairStyle,
    parents: TParents,
    serverTimestamp: any,
    common: Partial<CommonBookData> = {},
  ): BookWelcomeToTheWoldData {
    const newBook: BookWelcomeToTheWoldData = this.createEmptyBook();
    newBook.uid = uid;
    newBook.bookId = docId;
    newBook.heroName = heroName;
    newBook.birthDate = Timestamp.fromDate(birthDate);
    newBook.birthDateTimeZone = moment.tz.guess();
    newBook.hairStyle = hairStyle;
    newBook.parents = parents;
    newBook.createTimeStamp = serverTimestamp;
    newBook.steps.character.isDone = true;
    newBook.steps.parents.isDone = true;

    newBook.messageText = heroName + 'へ\n' +
      '\n' +
      'このせかいは　ふしぎで　すてきな\n' +
      'まほうで　いっぱいです。\n' +
      heroName + 'が　このせかいの　まほうに\n' +
      'たくさん　であえますように。\n' +
      'ここにきてくれて　どうもありがとう。';

    newBook.timeOfTheYear = MONTH_INDEX_TO_TIME_OF_THE_YEAR_MAP[birthDate.getMonth()];

    Object.assign(newBook, common);

    return newBook;
  }

  createEmptyBook(): BookWelcomeToTheWoldData {
    return {
      birthTime: null,
      steps: {
        character: {
          stepType: 'character',
          isDone: false
        },
        parents: {
          stepType: 'parents',
          isDone: false
        },
        message: {
          stepType: 'message',
          isDone: false
        },
        birthTime: {
          stepType: 'birthTime',
          isDone: false
        },
        photo: {
          stepType: 'photo',
          isDone: false
        },
      },
      alias: BOOK_ALIAS_WELCOME_TO_THE_WOLD,
      hairStyle: undefined,
      parents: undefined,
      createTimeStamp: undefined,
      uid: undefined,
      bookId: undefined,
      heroName: undefined,
      birthDate: null,
      bornTime: 'noinput',
      messageText: '',
      timeOfTheYear: undefined,
      fileUploadStatus: 0,
      cover: 'soft',
    };
  }
}
